// extracted by mini-css-extract-plugin
export var wordContainer = "_ss-0";